/**
 * SlxControls 1.2.36 ({@link https://www.selerix.com})
 * This is unpublished proprietary source code of Selerix Systems, Inc. The
 * copyright notice above is not evidence any actual or intended
 * publication of such source code.
 * @copyright Copyright 2024 Selerix Systems, Inc. All Rights Reserved.
 * @description Custom configuration settings for slxControls.
 * Copy this file and rename to slx.config.js
 */
(function (global) {
	'use strict';
	var x = global.SlxControl;

	// apply all custom config settings here
	// default script path
	x.slx.scriptpath = (global.__applicationRoot || (global.selerix || {}).applicationRoot || '') + 'selerix_common/lib/slx-controls/dist/js/';
	// slx base config
	x.slx.config = {
		// glyph icon classes
		icon: {
			danger: 'glyphicons glyphicons-exclamation-sign',
			warning: 'glyphicons glyphicons-warning-sign',
			info: 'glyphicons glyphicons-circle-info',
			success: 'halflings halflings-ok',
			'default': 'halflings halflings-ok'
		},
		// bootstrap version
		bootstrap: 3
	};

	return x;
})(window || this);